export const _venuetypes = [...Array(5)].map((_, index) => {
  const TYPE_NAMES = [
    "venue_tennis",
    "venue_table_tennis",
    "venue_basketball",
    "venue_football_large",
    "venue_badminton",
  ];

  return {
    id: index,
    name: TYPE_NAMES[index],
    image: TYPE_NAMES[index] + ".jpg",
    status: 1,
  };
});
